// extracted by mini-css-extract-plugin
module.exports = {"h1":"DataIn_h1__Q5GAB","rainbow":"DataIn_rainbow__kl9iD","imgTextWrapper":"DataIn_imgTextWrapper__GOZG9"};